export enum ProgressBarType {
  bullets,
  images,
  text,
  line,
}
